import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, ArrowRight, Linkedin, Facebook } from 'lucide-react';
import Logo from '@/components/Logo';
import { CONTACT_INFO } from '@/lib/content';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-bp-ink text-white" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">Footer</h2>

      <div className="border-b border-white/10">
        <div className="max-w-[1320px] mx-auto px-5 lg:px-8 py-14 lg:py-20 grid lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-8">
            <div className="kicker text-bp-teal"><span className="dot" style={{background:'#FB6A48'}}/>Ready when you are</div>
            <h3 className="font-display text-[32px] sm:text-[44px] lg:text-[54px] leading-[1.02] tracking-tight mt-3 text-white">
              Let&rsquo;s build something <span className="grad-text">your customers</span> love.
            </h3>
          </div>
          <div className="lg:col-span-4 flex flex-col gap-3">
            <Link to="/contact" className="btn-primary justify-center" data-testid="footer-cta-contact">
              Book a Free Strategy Call <ArrowRight size={16} />
            </Link>
            <a href={`tel:${CONTACT_INFO.phoneTel}`} className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-white/10 hover:bg-white/15 text-white font-semibold transition-colors" data-testid="footer-cta-phone">
              <Phone size={15} /> {CONTACT_INFO.phone}
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-[1320px] mx-auto px-5 lg:px-8 py-14 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo size="md" mono />
          <p className="mt-5 text-[15px] leading-relaxed text-white/70 max-w-md">
            Florida&rsquo;s digital marketing partner since 2007. Real partners. Real growth. Real results.
            Voted Top 25 Agency by South Florida Business Journal.
          </p>
          <ul className="mt-7 space-y-2.5 text-[14px] text-white/80">
            <li className="flex items-start gap-2"><MapPin size={14} className="text-bp-teal mt-1 flex-shrink-0"/><span>{CONTACT_INFO.addressLines.join(' · ')}</span></li>
            <li className="flex items-center gap-2"><Phone size={14} className="text-bp-teal"/><a href={`tel:${CONTACT_INFO.phoneTel}`} className="hover:text-white">{CONTACT_INFO.phone}</a></li>
            <li className="flex items-center gap-2"><Mail size={14} className="text-bp-teal"/><a href={`mailto:${CONTACT_INFO.email}`} className="hover:text-white">{CONTACT_INFO.email}</a></li>
          </ul>
          <div className="mt-5 flex gap-2">
            <a href={CONTACT_INFO.social.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="w-9 h-9 rounded-full bg-white/10 hover:bg-bp-blue flex items-center justify-center transition-colors"><Linkedin size={15}/></a>
            <a href={CONTACT_INFO.social.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-9 h-9 rounded-full bg-white/10 hover:bg-bp-blue flex items-center justify-center transition-colors"><Facebook size={15}/></a>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="font-semibold text-white text-[15px]">Agency</div>
          <ul className="mt-4 space-y-2.5 text-[14.5px] text-white/70">
            <li><Link className="hover:text-white" to="/why-us">Why Us</Link></li>
            <li><Link className="hover:text-white" to="/portfolio">Portfolio</Link></li>
            <li><Link className="hover:text-white" to="/articles">Articles</Link></li>
            <li><Link className="hover:text-white" to="/contact">Contact</Link></li>
            <li><Link className="hover:text-white" to="/accessibility">Accessibility</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="font-semibold text-white text-[15px]">Services</div>
          <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5 text-[14.5px] text-white/70">
            <li><Link className="hover:text-white" to="/services">SEO &amp; AEO</Link></li>
            <li><Link className="hover:text-white" to="/services">PPC &amp; Paid</Link></li>
            <li><Link className="hover:text-white" to="/services">Web Design</Link></li>
            <li><Link className="hover:text-white" to="/services">Social Media</Link></li>
            <li><Link className="hover:text-white" to="/services">Branding</Link></li>
            <li><Link className="hover:text-white" to="/services">Analytics</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1320px] mx-auto px-5 lg:px-8 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[13px] text-white/60">
          <div data-testid="footer-credit">
            Website Designed By{' '}
            <a
              href="https://bp.agency"
              target="_blank"
              rel="noopener noreferrer"
              className="font-bold text-white hover:text-bp-teal underline-offset-4 hover:underline"
            >
              Brand Partners
            </a>
          </div>
          <div>© {year} Brand Partners. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
}
